import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ImageUploadUtilInstantSave } from '@/components';
import { IMAGES, Product, useProduct } from '@/core';
import { AllergenPicker, EditProductForm } from '@/features';

type EditProductUtilProps = {
  initialProduct?: Product;
};

export const EditProductUtil = ({ initialProduct }: EditProductUtilProps) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const productId = Number(id);
  const {
    mutations: { updateMutation },
  } = useProduct();

  const imageSrc = initialProduct?.image_id
    ? `${window.API_URL}/${IMAGES}/${initialProduct.image_id}`
    : '';

  return (
    <Stack direction="row" justifyContent="space-between" gap={16}>
      <Stack direction="column">
        <EditProductForm />
      </Stack>
      <Stack direction="row" gap={3}>
        <AllergenPicker label={t('PRODUCT.SELECT_ALLERGENS')} />
        <ImageUploadUtilInstantSave
          entityId={productId}
          updateEntityMutation={updateMutation}
          queryKeysToInvalidateOnSuccess={[['product', productId]]}
          entityNameForMessages={'produkt'}
          initialImageSrc={imageSrc}
          initialImageId={initialProduct?.image_id}
        />
      </Stack>
    </Stack>
  );
};
